// Inform Typescript about global function
declare function gtag(...args: any[]): void;

function isGtagLoaded(): boolean {
  return typeof gtag === 'function';
}

export function gtagEvent(eventName: string, eventData?: Record<string, any>): void {
  if (isGtagLoaded()) {
    gtag('event', eventName, eventData);
  }
}